module.exports = __webpack_public_path__ + "img/113021.742bf44d.png";